import { render } from "./NewsAuthor.vue?vue&type=template&id=59a95168&scoped=true"
import script from "./NewsAuthor.vue?vue&type=script&lang=js"
export * from "./NewsAuthor.vue?vue&type=script&lang=js"

import "./NewsAuthor.vue?vue&type=style&index=0&id=59a95168&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a95168"]])

export default __exports__